/**
 * This is the entry file for the frontend application.
 */
import stateHandler, { CHANGE_STATE, STATE_CHANGED } from '../Handlers/StateHandler';
 
/** --------------------------------
 * Polyfill
 * -------------------------------- */

import Promise from 'bluebird';
global.Promise = Promise;


/** --------------------------------
 * Libraries
 * -------------------------------- */

import SmoothScroll from '../Libraries/smooth-scroll.polyfills';
new SmoothScroll('a[href*="#"]');

/** --------------------------------
 * Grid
 * -------------------------------- */

// Import grid layout
import GridLayout from '../../Views/Partials/Grid/Scripts/GridLayout';

// Instatiate GridLayout
new GridLayout();

/** --------------------------------
 * Service Worker
 * -------------------------------- */

import registerServiceWorker from '../Handlers/RegisterServiceWorker';
registerServiceWorker();

/** --------------------------------
 * Main styles
 * -------------------------------- */

 import '~/Styles/Index.scss';

/** --------------------------------
 * Components
 * -------------------------------- */

// Component styles
import './styles.js';

import { components, pages } from './components';

// Instatiate Components
components.map(Component => (
    new Component()
))
.forEach(component => {

    if(typeof component.on === 'function') {
        component.on(CHANGE_STATE, stateHandler.changeState);
    }

    if(typeof component._stateUpdated === 'function') {
        stateHandler.on(STATE_CHANGED, component._stateUpdated);
    }
});

// Instatiate Pages
pages.forEach(Page => (
    new Page()
));

/* // Instatiate Macro Partials
macropartials.forEach(Macro => (
  new Macro()
)); */